export default __webpack_public_path__ + "static/media/hajungwoo_desktop.558c5d85.png";